import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const sectionFn = /* @__PURE__ */ createRecipe('section', {
  "tone": "neutral",
  "variant": "flat",
  "size": "md"
}, [])

const sectionVariantMap = {
  "tone": [
    "neutral",
    "primary",
    "secondary",
    "inverse",
    "warm"
  ],
  "variant": [
    "flat",
    "alt",
    "gradient"
  ],
  "size": [
    "sm",
    "md",
    "lg",
    "xl"
  ]
}

const sectionVariantKeys = Object.keys(sectionVariantMap)

export const section = /* @__PURE__ */ Object.assign(memo(sectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'section',
  __getCompoundVariantCss__: sectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: sectionVariantKeys,
  variantMap: sectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, sectionVariantKeys)
  },
  getVariantProps: sectionFn.getVariantProps,
})